import { RiskRanges } from "../ranges";
import { Risk } from "../units";

function rangesFor() {
  return new RiskRanges("mmol/L", [
    { from: 4, to: 7, risk: Risk.Normal, label: "normal" },
    { from: 7, to: 9, risk: Risk.Risk, label: "elevated" },
    { from: 0, to: 4, risk: Risk.Risk, label: "low" },
    { from: 9, to: 12, risk: Risk.HighRisk, label: "high" },
  ]);
}

export const Glucose = {
  rangesFor,
};
